<template>
	<div class="c-notify-pill">
		<template v-if="showChanged">
			<span>Uppdaterad!</span>			
		</template>
		<template v-if="showUpdateCourse">
			<span>Kurser måste uppdateras</span>			
		</template>
	</div>
</template>

<script>
export default {
	name: 'NotifyPill',
	props: {
		notifications: {
			type: Array,
			default: () => []
		},
		label: {
			type: String,
			default: ''
		},
		showUpdateCourse: false
	},
	data() {
		return {
			showChanged: false
		}
	},
	created() {
		if (this.notifications.length > 0) {
			this.showChanged = true;
		}
	}
}
</script>
